import {
    //Dialog,
    // DialogTitle,
    DialogActions,
    //DialogContent,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Avatar,
    ListItemAvatar,
    Stack,
    Drawer

} from '@mui/material';

//import BadgeStatus from '../../../BadgeStatus';
import { LoadingButton } from '@mui/lab';
import HeaderModal from 'src/components/modal/HeaderModal';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { useEffect, useState } from 'react';
import { Switch } from 'src/@/components/ui/switch';
import { Button } from "src/@/components/ui/button"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/@/components/ui/popover"
import Iconify from 'src/components/Iconify';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { RowInput } from 'src/components/forms/RowInput';

// ----------------------------------------------------------------------

export default function ComponentCloseLead({ user, lead, onCallback, onClose, onOpen, open, onOpenChange }) {

    const [lista, setLista] = useState([]);
    const [isSendMessages, setIsSendMessages] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    async function editarLead(value) {
        try {
            // Check if lead.convertido is null
            if (lead.convertido === null) {
                enqueueSnackbar('Não é possível finalizar o negócio, pois o lead ainda não foi convertido.', {
                    variant: 'error',
                    autoHideDuration: 3000,
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
                });
                return; // Early exit if lead is not converted
            }

            // Proceed with the business finalization if lead.convertido is not null
            let data = {
                action: "finalizar_negocio",
                scope: {
                    closed: value,
                    data_finalizacao: new Date()
                }
            };
            setLoading(true);
            await v2_actionEditarLead(lead._id, data, user.id);
            onCallback();
            setLoading(false);
            enqueueSnackbar('Usuário alterado com sucesso', {
                variant: 'success',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
            });
        } catch (error) {
            console.log('error', error);
            enqueueSnackbar('Erro ao transferir usuário', {
                variant: 'error',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'left' }
            });
        }
    }

    return (
        <Popover open={open} onOpenChange={onOpenChange}>
            <PopoverTrigger asChild>
                <Button className="h-8" onClick={onOpen} variant="outline">
                    <Iconify icon="lets-icons:flag-finish" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999]">
                {lead.convertido ? (
                               <div className="flex flex-col gap-4">
                               <p className="leading-7 [&:not(:first-child)]:mt-6">
                                   Deseja realmente finalizar esse negócio?
                               </p>
                               <div className='flex gap-2'>
                                   <Button variant="outline" onClick={() => onOpenChange()}>Cancelar</Button>
                                   <ButtonLoading 
                                       loading={loading} 
                                       onClick={() => editarLead(true)} 
                                       disabled={!selectedUser && !lead?.convertido} 
                                       className={`${!selectedUser ? 'bg-slate-400' : 'bg-slate-700'} w-full`}
                                   >
                                       {loading ? 'Finalizando...' : 'Finalizar'}
                                   </ButtonLoading>
                               </div>
                           </div>
                  
                ) : (
                    <div className="flex flex-col gap-4">
                    <p className="text-[12px] [&:not(:first-child)]:mt-6">
                    Marque como <span className='font-bold'>perda</span> ou <span className='font-bold'>venda</span> antes de finalizar o negócio.
                </p>
                </div>
                )}
       
            </PopoverContent>
        </Popover>
    );
}

